/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import ScheduleLiveConsultation from '@brands/Dashboard/Dashboard/DashboardModals/ScheduleLiveConsultation';
import { convertDateFormat } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { SelectedAppointment } from '@brands/Dashboard/PatientForms/PatientForm/utils/types';
import CareAdvisorProfileCardModal from '@brands/Dashboard/ProfileCards/CareAdvisor/ProfileCards';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import {
  AvailabilitySlotDay,
  listCareAdvisorAvailabilityTimeSlots,
} from '@brands/services/availability/listCareAdvisorAvailabilities';
import { rescheduleCase, RescheduleCasePayload } from '@brands/services/cases/rescheduleCase';
import { CaseType, ICase } from '@brands/services/cases/types/ICase';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { getUserAvatar } from '@brands/services/identity/getUserAvatar';
import { Language } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setForm } from '@brands/store/slices/patientFormSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { needsPayment } from '@brands/Utils/needsPayment';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import { Button } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import Moment from 'moment';
import moment from 'moment-timezone';
import React, { useEffect, useMemo, useState } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Container from '../../../../Components/Container/Container';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import { isIntakePaymentQuestionComplete } from '../../../../Utils/isIntakePaymentQuestionComplete';
import useWindowSize from '../../../../hooks/useWindowSize';
import styles from './styles.module.scss';
import { formatTime } from './utils/utils';

const MAX_DAYS = 14;

const SelectCareAdvisorDetails = (): JSX.Element => {
  const { state } = useLocation();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { userInfo } = useAppSelector(selectAuth);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const RescheduleCase = state?.RescheduleCase ? state.RescheduleCase : searchParams.get('reschedule') || null;
  const screenSize = useWindowSize();
  const roleNavigate = useRoleNavigate();
  const [providerProfileCardModal, setCareAdvisorProfileCardModal] = useState<boolean>(false);
  const [providerParticipant, setCareAdvisorParticipant] = useState<any>(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<SelectedAppointment>({
    selectedDate: '',
    selectedTimeSlot: '',
    selectedDateTime: '',
    selectedCareAdvisorId: undefined,
  });
  const [rescheduleSuccessModal, setRescheduleSuccessModal] = useState<{
    openModal: boolean;
    updatedCase: ICase | null;
  }>({
    openModal: false,
    updatedCase: null,
  });
  const [availabilityDays, setAvailabilityDays] = useState<AvailabilitySlotDay[]>([]);
  const [visitDate, setVisitDate] = useState<string>('');
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true); // Default true
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [manualDateSelected, setManualDateSelected] = useState(false);
  const currentState: string = useAppSelector(selectCurrentPatientState);
  const [loading, setLoading] = useState(false);
  const provider = useMemo(() => {
    if (state?.provider_details) {
      return state.provider_details;
    }
    return values.find((item) => item.form_question_id === 14)?.value.selectedCareAdvisor || null;
  }, [state, values]);

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const isStaffPatientFlow = isUnifiedStaffCaseIntakeRole(userInfo.role.name);

  useEffect(() => {
    (async (): Promise<void> => {
      const getPricingsFn = async (): Promise<void> => {
        try {
          const pricings = await getPricings();
          dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings }));
        } catch (error: unknown) {
          displayErrorDetails(error);
        }
      };

      const listAvailabilityTimeSlotsParams = {
        tz: timezone,
      };

      await listCareAdvisorAvailabilityTimeSlots(provider?.id || 0, listAvailabilityTimeSlotsParams)
        .then((response) => {
          const days = response.days || [];
          setAvailabilityDays(days);
          setEndCursor(response.end_cursor || null);
          setHasNextPage(response.has_next_page && availabilityDays.length + days.length < MAX_DAYS);
        })
        .catch((error: unknown) => {
          displayErrorDetails(error);
          setAvailabilityDays([]);
        });

      if (!organizationPrices?.currentOrganizationPrices) {
        await getPricingsFn();
      }
    })();
  }, []);

  const caseType = useMemo(() => {
    return (
      (RescheduleCase
        ? state.caseType
        : (values.find((item) => item.form_question_id === 20)?.value.caseType as string)) ||
      CaseType.video_call_scheduled
    );
  }, [RescheduleCase, state, values]);

  const onSubmit = async (selectedAppointment: SelectedAppointment): Promise<void> => {
    if (selectedAppointment.selectedTimeSlot) {
      if (RescheduleCase && state?.caseId) {
        let updatedCase;
        try {
          setLoading(true);
          const payload: RescheduleCasePayload = {
            video_conference_date: convertDateFormat(`${selectedAppointment.selectedDateTime as string}`),
            clinician_id: selectedAppointment.selectedCareAdvisorId,
            case_type: CaseType.oral_health_coaching,
          };
          updatedCase = await rescheduleCase(state?.caseId, payload);

          setRescheduleSuccessModal({
            openModal: true,
            updatedCase: updatedCase as ICase,
          });
          setLoading(false);
        } catch (error: unknown) {
          displayErrorDetails(error);
        }
      } else {
        const filteredPayload = values.filter((item) => item.form_question_id !== 14);

        filteredPayload.push({
          form_question_id: 14,
          value: {
            selectedTimeSlot: selectedAppointment.selectedDateTime as string,
            selectedCareAdvisor: provider,
            ...(caseType !== CaseType.oral_health_coaching && {
              selectedCareAdvisorId: selectedAppointment.selectedCareAdvisorId,
            }),
            ...(caseType === CaseType.oral_health_coaching && {
              selectedCareAdvisorId: selectedAppointment.selectedCareAdvisorId,
            }),
          },
        });
        dispatch(setForm(filteredPayload));

        const currentOrganizationPrice = currentOrganizationPrices?.find((price: Pricings) =>
          price.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
        );

        const q19Value = values.find((item) => item.form_question_id === 19)?.value as
          | Record<string, unknown>
          | undefined;

        if (isStaffPatientFlow && isIntakePaymentQuestionComplete(q19Value)) {
          roleNavigate('/confirm-payment');
        } else if (needsPayment(currentOrganizationPrice)) {
          roleNavigate('/payment-information');
        } else {
          roleNavigate('/confirm-payment');
        }
      }
    } else {
      roleNavigate('/select-care-advisor-details', {
        state: {
          caseType,
          patientId: selectedPatient?.value,
          care_advisor_id: selectedTimeSlot.selectedCareAdvisorId,
        },
      });
    }
  };

  const handleTimeSlotClick = async (date: string, slot: string, care_advisor_id: number): Promise<void> => {
    const currentTime = Moment(); // Get the current time
    const startTimeMoment = Moment(slot);
    const isCurrentDate = startTimeMoment.isSame(moment(), 'day');

    if (isCurrentDate) {
      const isPast = startTimeMoment.isBefore(currentTime);
      if (isPast) {
        toast.error('The time slot you selected is in the past. Please select a different time slot.', {
          className: 'fs-unmask',
        });
        return;
      }
    }

    if ((startTimeMoment.diff(currentTime, 'minutes') >= 30 && isCurrentDate) || !isCurrentDate) {
      const formattedForDisplay = startTimeMoment.format('dddd, MMMM D, YYYY h:mm a'); // 👈 For storing in Redux
      const formattedForSubmission = formatTime(startTimeMoment.toDate());
      await setSelectedTimeSlot({
        selectedDate: date,
        selectedTimeSlot: formattedForSubmission,
        selectedDateTime: formattedForDisplay,
        selectedCareAdvisorId: care_advisor_id,
      });
      onSubmit({
        selectedDate: date,
        selectedTimeSlot: formattedForSubmission,
        selectedDateTime: formattedForDisplay,
        selectedCareAdvisorId: care_advisor_id,
      });
    } else {
      toast.error('The time slot you selected is no longer available. Please select a different time slot.', {
        className: 'fs-unmask',
      });
      await setSelectedTimeSlot({
        selectedDate: '',
        selectedTimeSlot: '',
        selectedDateTime: '',
        selectedCareAdvisorId: undefined,
      });
    }
  };

  const goBackToSelectCareAdvisor = (): void => {
    dispatch(setForm(values.filter((item) => item.form_question_id !== 14)));

    roleNavigate('/select-care-advisor', {
      state: {
        caseType,
        patientId: selectedPatient?.value,
        care_advisor_id: selectedTimeSlot.selectedCareAdvisorId,
        RescheduleCase: state?.RescheduleCase,
        caseId: state?.caseId,
      },
    });
  };

  const loadAvailabilityDays = async (cursorParam: string | null = null): Promise<void> => {
    if (!provider?.id || isLoadingMore || !hasNextPage || availabilityDays.length >= MAX_DAYS) return;

    try {
      setIsLoadingMore(true);
      const response = await listCareAdvisorAvailabilityTimeSlots(provider.id, {
        tz: timezone,
        limit: Math.min(3, MAX_DAYS - availabilityDays.length), // Only fetch remaining days
        cursor: cursorParam || undefined,
      });

      const days = response.days || [];
      setAvailabilityDays((prev) => {
        if (manualDateSelected && visitDate) {
          // Overwrite with only the manually selected day's data
          return days.filter((day) => day.date === visitDate);
        }
        // Otherwise, merge new days into the existing list, avoiding duplicates
        return [...prev, ...days.filter((day) => !prev.some((d) => d.date === day.date))];
      });

      setEndCursor(response.end_cursor || null);
      setHasNextPage(response.has_next_page && availabilityDays.length + days.length < MAX_DAYS);
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setIsLoadingMore(false);
    }
  };

  if (loading) {
    return <Loading dotted />;
  }

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{
        zIndex: '2',
        paddingTop: '24px',
        paddingBottom: '0px',
      }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.providerSelectContainer}`}>
        <PatientIntakeNavigation progress={12} />
        <form className={`${styles.formContainer}`}>
          <div className={styles.providerSelectWrapper}>
            <div className={styles.providerSelectTitleContainer}>
              <div className={styles.providerSelectTitle}>Select a timeslot</div>
              {screenSize.width >= 768 && <div className={styles.providerSelectSubtitle}>Times are in {timezone}</div>}
            </div>

            <div className={styles.providerSelect}>
              <div className={styles.providerSelectItemDetails}>
                <div
                  className={styles.imageContainer}
                  onClick={() => {
                    setCareAdvisorParticipant(provider.user);
                    setCareAdvisorProfileCardModal(true);
                  }}
                >
                  <img
                    alt="Avatar"
                    className={`fs-exclude ${styles.providerImage}`}
                    src={getUserAvatar(provider?.id || 0)}
                    onError={(e) => {
                      e.currentTarget.src = '/assets/images/default-avatar.svg';
                    }}
                  />
                </div>

                <div className={styles.providerSelectItemDetailsTextContainer}>
                  <div className={styles.providerSelectItemDetailsText}>
                    <div
                      className={`fs-exclude ${styles.providerName}`}
                      onClick={() => {
                        setCareAdvisorParticipant(provider.user);
                        setCareAdvisorProfileCardModal(true);
                      }}
                    >
                      {provider.user.full_name}
                    </div>

                    <div className={styles.providerLanguages}>
                      <span className={styles.providerLanguagesLabel}>Languages: </span>
                      <span className={styles.providerLanguages}>
                        {provider.user?.basic_info?.languages?.length
                          ? provider.user.basic_info.languages.map((lang: Language) => lang?.name).join(', ')
                          : 'No languages available'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.providerSelectVisitDate}>
                <div className={styles.providerSelectVisitDateLabel}>Visit Date</div>
                <div className={styles.providerSelectVisitDateInput}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      format="MM/DD/YYYY"
                      value={visitDate ? dayjs(visitDate) : null}
                      minDate={dayjs()}
                      maxDate={dayjs().add(1, 'year')}
                      onChange={(newValue) => {
                        const year = newValue?.year();
                        if (newValue?.isValid() && year && year >= 1000 && year <= 9999) {
                          const today = dayjs();
                          const nextYear = today.add(1, 'year');

                          if (newValue.isAfter(today, 'day') && newValue.isBefore(nextYear, 'day')) {
                            const selectedDate = newValue.format('YYYY-MM-DD');
                            setManualDateSelected(true);
                            setVisitDate(selectedDate);
                            setSelectedTimeSlot({
                              selectedDate,
                              selectedTimeSlot: '',
                              selectedDateTime: '',
                              selectedCareAdvisorId: provider.id,
                            });

                            const listAvailabilityTimeSlotsParams = {
                              tz: timezone,
                              date: selectedDate,
                            };

                            listCareAdvisorAvailabilityTimeSlots(provider.id, listAvailabilityTimeSlotsParams)
                              .then((response) => {
                                const days = response.days || [];
                                setAvailabilityDays(days);
                                setEndCursor(response.end_cursor || null);
                                setHasNextPage(
                                  response.has_next_page && availabilityDays.length + days.length < MAX_DAYS,
                                );
                              })
                              .catch((error: unknown) => {
                                displayErrorDetails(error);
                                setAvailabilityDays([]);
                              });
                          } else {
                            displayErrorDetails('Please select a date between today and one year from now.');
                          }
                        }
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          className: styles.providerSelectVisitDateInputField,
                          inputProps: {
                            readOnly: false,
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
              {availabilityDays.map((day, index) => {
                return (
                  <div key={index} className={styles.providerSelectItemTimeSlots}>
                    <div className={styles.providerSelectItemTimeSlotsLabel}>
                      {day.date_label || Moment(day.date).format('dddd, MMMM D, YYYY')}
                    </div>
                    <div className={styles.providerSelectItemTimeSlotContainer}>
                      {day.sync_time_slots.length > 0 ? (
                        day.sync_time_slots?.map((slot: string, i: number) => {
                          const slotStr = Moment(slot).format();
                          return (
                            <Button
                              key={i}
                              color="primary"
                              variant="outlined"
                              className={`${styles.providerSelectItemTimeSlot} ${
                                selectedTimeSlot.selectedDate === day.date &&
                                selectedTimeSlot.selectedTimeSlot === formatTime(Moment(slot).toDate()) &&
                                selectedTimeSlot.selectedCareAdvisorId === provider.id
                                  ? styles.selectedTimeSlot
                                  : ''
                              }`}
                              onClick={() => handleTimeSlotClick(day.date, slotStr, provider.id)}
                            >
                              {Moment(slotStr).format('h:mma')}
                            </Button>
                          );
                        })
                      ) : (
                        <div className={styles.noTimeSlots}>No available appointments</div>
                      )}
                    </div>
                  </div>
                );
              })}
              {hasNextPage && endCursor && (
                <span className={styles.seeMore} onClick={() => loadAvailabilityDays(endCursor)}>
                  See more openings
                </span>
              )}
            </div>

            <div className={styles.providerSelectFooter}>
              <button
                type="button"
                className={styles.providerSelectFooterBackButton}
                onClick={() => goBackToSelectCareAdvisor()}
              >
                <FaChevronLeft />
                Back
              </button>
            </div>
          </div>
        </form>
        {providerProfileCardModal && (
          <CareAdvisorProfileCardModal
            isOpen={providerProfileCardModal}
            toggleModal={setCareAdvisorProfileCardModal}
            caIdentity={providerParticipant}
          />
        )}
        {isLoadingMore && <div className={styles.loadingMore}>Loading more days...</div>}
        {rescheduleSuccessModal.openModal && (
          <ScheduleLiveConsultation newCase={rescheduleSuccessModal.updatedCase as ICase} isRescheduled />
        )}
      </div>
    </Container>
  );
};
export default SelectCareAdvisorDetails;
